export default {
  'component.tagSelect.expand': '展开',
  'component.tagSelect.collapse': '收起',
  'component.tagSelect.all': '全部',
  'component.global.ok': '确定',
  'component.global.cancel': '取消',
  'component.global.search': '搜索',
};
